const EMPLOYEE_EDIT_MESSAGES = {
  HEADING: 'Edit Employee',
}

export default EMPLOYEE_EDIT_MESSAGES
